export const Api_url = "/api";

// Authentication
export const POST_ADMIN_LOGIN = `${Api_url}/admins/login`;
export const POST_AGENT_LOGIN = `${Api_url}/agents/login`;
export const POST_MOBILE_LOGIN = `${Api_url}/admins/mobile-login`;
export const POST_ADMIN_LOGOUT = `${Api_url}/admins/logout`;

// Agent URLs
export const CREATE_AGENT = `${Api_url}/agents`;
export const UPDATE_AGENT = `${Api_url}/agents`;
export const DELETE_AGENT = `${Api_url}/agents`;
export const GET_ALL_AGENTS = `${Api_url}/agents`;
export const GET_AGENT_BY_ID = `${Api_url}/agents`;

// Admin URLs
export const CREATE_ADMIN = `${Api_url}/admins`;
export const UPDATE_ADMIN = `${Api_url}/admins`;
export const GET_ALL_ADMINS = `${Api_url}/admins`;
export const GET_ADMIN_BY_ID = `${Api_url}/admins`;
export const GET_ALL_LOAN_BY_ADMIN_ID = `${Api_url}/admins`;
export const GET_ALL_LOANS_COUNT_BY_ADMIN_ID = `${Api_url}/admins/count`;
export const UPDATE_PASSWORD = `${Api_url}/admins/change-password`;
export const FORGOT_PASSWORD = `${Api_url}/admins/forgot-password`;
export const GET_ADMIN_BY_EMAIL = `${Api_url}/admins/by-email`;
export const GET_ADMIN_BY_MOBILE = `${Api_url}/admins/by-mobile`;
export const DELETE_CUSTOMER = `${Api_url}/admins/delete`;

// Location URLs
export const GET_ALL_CITIES = `${Api_url}/cities`;
export const GET_ALL_STATES = `${Api_url}/states`;
export const GET_ALL_PINCODES = `${Api_url}/pincode`;

// Business Loan URLs
export const CREATE_BUSINESS_LOAN = `${Api_url}/business-loans`;
export const UPDATE_BUSINESS_LOAN = `${Api_url}/business-loans`;
export const DELETE_BUSINESS_LOAN = `${Api_url}/business-loans`;
export const GET_ALL_BUSINESS_LOANS = `${Api_url}/business-loans`;
export const GET_BUSINESS_LOAN_BY_ID = `${Api_url}/business-loans`;
export const GET_BUSINESS_LOAN_BY_ADMIN_ID = `${Api_url}/business-loans/admin`;
export const GET_BUSINESS_LOAN_BY_EMAIL = `${Api_url}/business-loans/by-email`;
export const GET_BUSINESS_LOAN_BY_MOBILE = `${Api_url}/business-loans/by-mobile`;

// Car Loan URLs
export const CREATE_CAR_LOAN = `${Api_url}/car-loans`;
export const UPDATE_CAR_LOAN = `${Api_url}/car-loans`;
export const DELETE_CAR_LOAN = `${Api_url}/car-loans`;
export const GET_ALL_CAR_LOANS = `${Api_url}/car-loans`;
export const GET_CAR_LOAN_BY_ID = `${Api_url}/car-loans`;
export const GET_CAR_LOAN_BY_ADMIN_ID = `${Api_url}/car-loans/admin`;
export const GET_CAR_LOAN_BY_EMAIL = `${Api_url}/car-loans/by-email`;
export const GET_CAR_LOAN_BY_MOBILE = `${Api_url}/car-loans/by-mobile`;

// Home Loan URLs
export const CREATE_HOME_LOAN = `${Api_url}/home-loans`;
export const UPDATE_HOME_LOAN = `${Api_url}/home-loans`;
export const DELETE_HOME_LOAN = `${Api_url}/home-loans`;
export const GET_ALL_HOME_LOANS = `${Api_url}/home-loans`;
export const GET_HOME_LOAN_BY_ID = `${Api_url}/home-loans`;
export const GET_HOME_LOAN_BY_ADMIN_ID = `${Api_url}/home-loans/admin`;
export const GET_HOME_LOAN_BY_EMAIL = `${Api_url}/home-loans/by-email`;
export const GET_HOME_LOAN_BY_MOBILE = `${Api_url}/home-loans/by-mobile`;

// Credit Card Loan URLs
export const CREATE_CREDIT_CARD_LOAN = `${Api_url}/credit-card-loans`;
export const UPDATE_CREDIT_CARD_LOAN = `${Api_url}/credit-card-loans`;
export const DELETE_CREDIT_CARD_LOAN = `${Api_url}/credit-card-loans`;
export const GET_ALL_CREDIT_CARD_LOANS = `${Api_url}/credit-card-loans`;
export const GET_CREDIT_CARD_LOAN_BY_ID = `${Api_url}/credit-card-loans`;
export const GET_CREDIT_LOAN_BY_ADMIN_ID = `${Api_url}/credit-card-loans/admin`;
export const GET_CREDIT_CARD_LOAN_BY_EMAIL = `${Api_url}/credit-card-loans/by-email`;
export const GET_CREDIT_CARD_LOAN_BY_MOBILE = `${Api_url}/credit-card-loans/by-mobile`;

// Insurance Loan URLs
export const CREATE_INSURANCE_LOAN = `${Api_url}/insurance-loans`;
export const UPDATE_INSURANCE_LOAN = `${Api_url}/insurance-loans`;
export const DELETE_INSURANCE_LOAN = `${Api_url}/insurance-loans`;
export const GET_ALL_INSURANCE_LOANS = `${Api_url}/insurance-loans`;
export const GET_INSURANCE_LOAN_BY_ID = `${Api_url}/insurance-loans`;
export const GET_INSURANCE_LOAN_BY_ADMIN_ID = `${Api_url}/insurance-loans/admin`;
export const GET_INSURANCE_LOAN_BY_EMAIL = `${Api_url}/insurance-loans/by-email`;
export const GET_INSURANCE_LOAN_BY_MOBILE = `${Api_url}/insurance-loans/by-mobile`;

// Mortgage Loan URLs
export const CREATE_MORTGAGE_LOAN = `${Api_url}/mortgage-loans`;
export const UPDATE_MORTGAGE_LOAN = `${Api_url}/mortgage-loans`;
export const DELETE_MORTGAGE_LOAN = `${Api_url}/mortgage-loans`;
export const GET_ALL_MORTGAGE_LOANS = `${Api_url}/mortgage-loans`;
export const GET_MORTGAGE_LOAN_BY_ID = `${Api_url}/mortgage-loans`;
export const GET_MORTGAGE_LOAN_BY_ADMIN_ID = `${Api_url}/mortgage-loans/admin`;
export const GET_MORTGAGE_LOAN_BY_EMAIL = `${Api_url}/mortgage-loans/by-email`;
export const GET_MORTGAGE_LOAN_BY_MOBILE = `${Api_url}/mortgage-loans/by-mobile`;

// Personal Loan URLs
export const CREATE_PERSONAL_LOAN = `${Api_url}/personal-loans`;
export const UPDATE_PERSONAL_LOAN = `${Api_url}/personal-loans`;
export const DELETE_PERSONAL_LOAN = `${Api_url}/personal-loans`;
export const GET_ALL_PERSONAL_LOANS = `${Api_url}/personal-loans`;
export const GET_PERSONAL_LOAN_BY_ID = `${Api_url}/personal-loans`;
export const GET_PERSONAL_LOAN_BY_ADMIN_ID = `${Api_url}/personal-loans/admin`;
export const GET_PERSONAL_LOAN_BY_EMAIL = `${Api_url}/personal-loans/by-email`;
export const GET_PERSONAL_LOAN_BY_MOBILE = `${Api_url}/personal-loans/by-mobile`;

// Doctor Loan URLs
export const CREATE_DOCTOR_LOAN = `${Api_url}/doctor-loans`;
export const UPDATE_DOCTOR_LOAN = `${Api_url}/doctor-loans`;
export const DELETE_DOCTOR_LOAN = `${Api_url}/doctor-loans`;
export const GET_ALL_DOCTOR_LOANS = `${Api_url}/doctor-loans`;
export const GET_DOCTOR_LOAN_BY_ID = `${Api_url}/doctor-loans`;
export const GET_DOCTOR_LOAN_BY_ADMIN_ID = `${Api_url}/doctor-loans/admin`;
export const GET_DOCTOR_LOAN_BY_EMAIL = `${Api_url}/doctor-loans/by-email`;
export const GET_DOCTOR_LOAN_BY_MOBILE = `${Api_url}/doctor-loans/by-mobile`;

// Nri Loan URLs
export const CREATE_NRI_LOAN = `${Api_url}/nri`;
export const UPDATE_NRI_LOAN = `${Api_url}/nri`;
export const DELETE_NRI_LOAN = `${Api_url}/nri`;
export const GET_ALL_NRI_LOANS = `${Api_url}/nri`;
export const GET_NRI_LOAN_BY_ID = `${Api_url}/nri`;
export const GET_NRI_LOAN_BY_ADMIN_ID = `${Api_url}/nri/admin`;
export const GET_NRI_LOAN_BY_EMAIL = `${Api_url}/nri/by-email`;
export const GET_NRI_LOAN_BY_MOBILE = `${Api_url}/nri/by-mobile`;

// OTP URLs
export const SEND_OTP = `${Api_url}/otp/send`;
export const VERIFY_OTP = `${Api_url}/otp/verify`;
export const RESEND_OTP = `${Api_url}/otp/resend`;

// Bank
export const CREATE_BANK = `${Api_url}/banks`;
export const UPDATE_BANK = `${Api_url}/banks`;
export const GET_ALL_BANKS = `${Api_url}/banks/all-banks`;
export const DELETE_BANK = `${Api_url}/banks`;
export const GET_BANK_ID = `${Api_url}/banks`;
export const GET_BANK_IDS = `${Api_url}/banks/bank-lists`;

//Company URLs
export const CREATE_COMPANY = `${Api_url}/company`;
export const UPDATE_COMPANY = `${Api_url}/company`;
export const DELETE_COMPANY = `${Api_url}/company`;
export const GET_ALL_COMPANIES = `${Api_url}/company/all-companies`;
export const GET_COMPANY_BY_ID = `${Api_url}/company`;
export const GET_COMPANY_BANK_IDS = `${Api_url}/company/banks`;

//Company Based Banks URLs
export const GET_ALL_CAR_LOAN_BANKS = `${Api_url}/company/car-loan-banks`;
export const GET_ALL_HOME_LOAN_BANKS = `${Api_url}/company/home-loan-banks`;
export const GET_ALL_PERSONAL_LOAN_BANKS = `${Api_url}/company/personal-loan-banks`;
export const GET_ALL_MORTGAGE_LOAN_BANKS = `${Api_url}/company/mortgage-loan-banks`;
export const GET_ALL_CREDIT_CARD_LOAN_BANKS = `${Api_url}/company/credit-card-loan-banks`;
export const GET_ALL_INSURANCE_LOAN_BANKS = `${Api_url}/company/insurance-loan-banks`;
export const GET_ALL_NRI_LOAN_BANKS = `${Api_url}/company/nri-loan-banks`;

// Bulk Company
export const BULK_UPLOAD_COMPANIES = `${Api_url}/company/upload-company-csv`;
export const BULK_DELETE_COMPANIES = `${Api_url}/company/delete-company-csv`;

//Without Company Based Banks
export const GET_BUSINESS_LOAN_BANK_LIST = `${Api_url}/banks/business-loan-banks`;
export const GET_DOCTOR_LOAN_BANK_LIST = `${Api_url}/banks/doctor-loan-banks`;
export const GET_HOME_LOAN_BANK_LIST = `${Api_url}/banks/home-loan-banks`;
export const GET_PERSONAL_LOAN_BANK_LIST = `${Api_url}/banks/personal-loan-banks`;
export const GET_MORTGAGE_LOAN_BANK_LIST = `${Api_url}/banks/mortgage-loan-banks`;
export const GET_NRI_LOAN_BANK_LIST = `${Api_url}/banks/nri-loan-banks`;

//Customer
export const CREATE_OR_GET_CUSTOMER = `${Api_url}/admins/customer`;